// Shared season-filter persistence. Every top-level page that has a season
// dropdown (Competitions, Results, Statistics, Season Stats) writes to and
// reads from the same localStorage key, so a user's chosen season stays
// selected as they navigate between pages and returns on next login.
const STORAGE_KEY = "ccs.selectedSeasonId";

// Pick which season to select given the fetched list. Priority:
//   1. Previously stored id, if it still exists in the list
//   2. The active season (server-marked)
//   3. Empty string ("All seasons")
export function pickInitialSeasonId(seasons) {
  const stored = readSeasonPref();
  if (stored && seasons.some((s) => s.id === stored)) return stored;
  const active = seasons.find((s) => s.is_active);
  return active ? active.id : "";
}

export function readSeasonPref() {
  try {
    return localStorage.getItem(STORAGE_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function saveSeasonPref(id) {
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    // localStorage disabled (private mode / cookies-blocked). Silently
    // fall through — the dropdown still works, just won't remember.
  }
}
